<template>
    <div :id="id" class="selection relative inline-block overflow-hidden" :style="root">
        <select v-model="selected" @input="onSelect" @change="onChange" class="w-full h-full" :style="select">
            <slot />
        </select>
        <i class="indicator fas fa-chevron-down shadow-text-none absolute" :style="indicator"></i>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: ''
        },

        id: {
            type: String,
            required: true
        },

        root: {
            type: Object,
            default: () => {
                return { backgroundColor: '#fff' }
            }
        },

        select: {
            type: Object,
            default: () => {
                return { color: '#333', fontSize: '1rem' }
            }
        },

        indicator: {
            type: Object,
            default: () => {
                return { color: 'rgba(60, 60, 60, 0.5)' }
            }
        }
    },

    data() {
        return {
            selected: '',
            observer: null
        }
    },

    mounted() {
        this.selected = this.value
    },

    methods: {
        onSelect(event) {
            this.$emit('input', event.target.value)
        },

        onChange(event) {
            this.$emit('change', event.target.value)
        }
    },

    watch: {
        value(data) {
            this.selected = data
        }
    }
}
</script>

<style lang="scss">
.selection {
    height: 2.5rem;
    padding: 0 !important;
    border: 1px solid #ccc;
    border-radius: 0.25rem;

    .indicator {
        position: absolute;
        right: 0.75rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1rem;
        background-image: var(--indicator);
        background-repeat: no-repeat;
        background-size: contain;
        pointer-events: none;
    }

    > select {
        border: none;
        background-color: transparent;
        font-size: 1rem;
        color: #333;
        text-indent: 0.75rem;
        appearance: none;
        -moz-appearance: none; /* Firefox */
        -webkit-appearance: none; /* Safari and Chrome */
    }
}
</style>